export default "__VITE_ASSET__41380984__"